module.exports = {"name":"CopyTest","parameters":[]}